// {{WORKTREE_ROOT}}/picosponsorconsole/packages/design/src/cx.ts
// PLAN2 WP09 — tailwind-merge 2.6.1 configured for the preset's custom scales (C-95), so a consumer's className wins
// over a component's own utility for the same property: cx("p-4", "p-6") → "p-6"; cx("text-13", "text-ink") keeps both
// (size vs colour); cx("text-13", "text-15") → "text-15"; font-size never evicts leading (sizes carry no line-height).
import { extendTailwindMerge } from "tailwind-merge";
import { COLOR_NAMES, FONT_SIZES_PX, LINE_HEIGHTS, letterSpacingEm, spacingPx } from "./tailwind-preset.js";

const isArbitrary = (value: string) => /^\[.+\]$/.test(value);
const SPACING = [...Object.keys(spacingPx), isArbitrary];

export const cx = extendTailwindMerge({
  override: {
    theme: {
      colors: [...COLOR_NAMES, isArbitrary],
      spacing: SPACING,
      borderRadius: ["none", "round"],
      borderWidth: ["", "0", "1", "1.5", "2", "3", "4", "6"],
    },
    classGroups: {
      "font-size": [{ text: [...FONT_SIZES_PX.map(String), isArbitrary] }],
      leading: [{ leading: [...LINE_HEIGHTS.map(String), isArbitrary] }],
      tracking: [{ tracking: [...Object.keys(letterSpacingEm), isArbitrary] }],
      "font-family": [{ font: ["sans", "mono"] }],
      shadow: [{ shadow: ["none", "print", "lift", "hairline", "spotlight"] }],
      animate: [{ animate: ["none", "pulse", "sweep-in"] }],
      "bg-image": [{ bg: ["none", "hatch", "hatch-soft", "hatch-dark"] }],
    },
    conflictingClassGroups: { "font-size": [] },
  },
  extend: {
    classGroups: {
      w: [{ w: [(value: string) => /^pct-(\d|[1-9]\d|100)$/.test(value), "rail"] }],
      "min-h": [{ "min-h": ["target", "target-primary", "target-capture"] }],
      "min-w": [{ "min-w": ["target", "target-primary", "target-capture"] }],
      "max-w": [{ "max-w": ["console", "site"] }],
    },
  },
});
